<template>
  <v-data-table
    item-key="id"
    :options.sync="tableOptions"
    :items-per-page="10"
    :server-items-length="count"
    :headers="headers"
    :footer-props="footerTable"
    :items="items"
    sort-by="name"
    v-bind="this.$attrs"
    loading-text="Đang Tải"
    :loading="loading"
    no-data-text="Không có buổi"
    disable-sort
  >
    <template v-slot:[`item.date`]="{ item }">
      {{ item.date | ddmm }}
    </template>
    <!-- <template v-slot:[`item.date`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div v-on="on" style="text-decoration: none; white-space: nowrap">
            <router-link
              v-on="on"
              style="text-decoration: none; white-space: nowrap"
              :to="'/boarding-class-session/' + item.id"
            >
              {{ item.date | ddmm }}
            </router-link>
          </div>
        </template>
        <span>Xem buổi bán trú</span>
      </v-tooltip>
    </template> -->
    <template v-slot:[`item.name`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div v-on="on" style="text-decoration: none; white-space: nowrap">
            <router-link
              v-on="on"
              style="text-decoration: none; white-space: nowrap"
              :to="'/boarding-class-session/' + item.id"
            >
              {{ item.boardingClassTitle }}
            </router-link>
          </div>
        </template>
        <span>Xem buổi bán trú</span>
      </v-tooltip>
    </template>
    <template v-slot:[`item.attendanceCount`]="{ item }"> {{ item.attendanceCount }} / {{ item.totalCount }} </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-chip
        small
        style="margin: 0"
        class="white--text"
        v-if="item.status"
        :color="item.status | boardingClassSessionStatusColor"
        label
      >
        {{ item.status | boardingClassSessionStatusText }}
      </v-chip>
    </template>

    <template v-slot:[`item.updatedBy`]="{ item }">
      {{ item.updatedBy }}
    </template>

    <template v-slot:[`item.updatedAt`]="{ item }">
      {{ item.updatedAt | ddmmyyyy }}
    </template>
    <!-- Thao tác -->
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn icon color="primary">
        <router-link
          v-on="on"
          style="text-decoration: none; white-space: nowrap"
          :to="'/boarding-class-session/' + item.id"
        >
          <v-icon>mdi-eye-outline</v-icon></router-link
        >
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'vuex'

const originHeaders = [
  { text: 'Buổi', value: 'date' },
  { text: 'Tên lớp bán trú', value: 'name' },
  { text: 'Có mặt', value: 'attendanceCount' },
  { text: 'Trạng thái', value: 'status' },
  { text: 'Điểm danh bởi', value: 'updatedBy' },
  { text: 'Thời gian điểm danh', value: 'updatedAt' },
  { text: 'Thao tác', value: 'actions' },
]

export default {
  props: {},
  data() {
    return {
      headers: originHeaders,
      status: null,
      tableOptions: {},
    }
  },
  methods: {
    ...mapActions('boardingClassSession', ['requestPageSettings', 'search']),
    cancel() {
      this.$emit('cancel')
      this.dialog = false
    },
    async refresh(query) {
      await this.search(query || {})
    },
  },
  computed: {
    ...mapState('boardingClassSession', ['items', 'count', 'pageText', 'loading']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Buổi mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
          })
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
